module.exports = __webpack_public_path__ + "img/tpc-3.385d0792.jpg";